module.exports.v1 = {
  ADMIN_LOGIN: "/api/v1/admin/login",
  ADMIN_LOGOUT: "/api/v1/admin/logout",
  GENERATE_SHARE_LINK: "/api/v1/shareLink/:postId",
  EXCHANGE_SHARE_LINK: "/api/v1/exchangeEncryptedId",

  CUSTOMER_AUTH: "/api/v1/auth/login/email",
  CUSTOMER_AUTH_FACEBOOK: "/api/v1/auth/login/facebook",
  CUSTOMER_AUTH_GOOGLE: "/api/v1/auth/login/google",
  CUSTOMER_AUTH_APPLE: "/api/v1/auth/login/apple",
  CUSTOMER_REGISTER: "/api/v1/register",
  CUSTOMER_LOGOUT: "/api/v1/auth/logout",
  CUSTOMER_REGISTER_TOKEN: "/api/v1/token",
  CUSTOMER_REPORT: "/api/v1/customer/report",
  CUSTOMER_BLOCK: "/api/v1/customer/block",
  CUSTOMER_BLOCK_LIST: "/api/v1/customer/block-list",

  RESET_PASSWORD: "/api/v1/reset-pwd",
  FORGOT_PASSWORD: "/api/v1/forgot-pwd",
  RESET_PASSWORD_VERIFY: "/api/v1/reset-pwd/verify",
  CUSTOMER_PHONE_NUMBER_VERIFY: "/api/v1/phone/verif/send",
  CUSTOMER_PHONE_NUMBER_VERIFY_CODE: "/api/v1/phone/verif/code",
  CUSTOMER_EMAIL_VERIFY: "/api/v1/email/verif/send",
  CUSTOMER_EMAIL_VERIFY_CODE: "/api/v1/email/verif/code",
  //dashboard api
  GET_DASHBOARD_DATA: "/api/v1/dashboard",
  GET_TRANSACTION_GRAPH: "/api/v1/transaction-graph",
  GET_POST_GRAPH: "/api/v1/post-graph",
  GET_UPLOAD_GRAPH: "/api/v1/upload-graph",

  //report api
  REPORT_ACTIVE_USER: "/api/v1/user-active",
  REPORT_STICK_USER: "/api/v1/user-stick",

  GET_REPORT_DATA: "/api/v1/report",
  GET_ACTIVITY_USERS: "/api/v1/activity-users",
  GET_REVENUE_DATA: "/api/v1/revenue",
  GET_NUMERIC_REPORT: "/api/v1/numeric-report",

  //customer api
  CUSTOMERS_ID: "/api/v1/customers/:id",
  CUSTOMERS: "/api/v1/customers",
  CUSTOMER_NOTIFICATION: "/api/v1/customers/:id/notification",
  CUSTOMER_RESET_PASSWORD: "/api/v1/customer/reset-pwd",
  CUSOMTERS_NEAR_BY: "/api/v1/nearby/customers",
  CUSTOMER_UPDATE_EMAIL: "/api/v1/customer/update-email",
  CUSTOMER_UPDATE_PASSWORD: "/api/v1/customer/update-password",

  BUY_ITEM: "/api/v1/item/buy",

  //favorite api
  FAVORITES: "/api/v1/favorites",
  FAVORITES_id: "/api/v1/favorites/:id",

  //chat api
  CHAT_ROOMS: "/api/v1/chat-rooms",
  CHAT_ROOMS_ID: "/api/v1/chat-rooms/:id",

  MESSAGES: "/api/v1/messages",
  MESSAGES_ID: "/api/v1/messages/:id",
  MESSAGE_AS_READ: "/api/v1/message/read",

  //post api
  TRIPS: "/api/v1/trip-plans",
  TRIPS_ID: "/api/v1/trip-plans/:id",
  TRIPS_DETAIL_BY_ID: "/api/v1/trip-plans/detail/:id",
  TRIP_INVITE: "/api/v1/trip-plans/invite",
  TRIP_ACCEPT: "/api/v1/trip-plans/accept/:token",

  POSTS: "/api/v1/posts",
  POST_CREATE: "/api/v1/post",
  POSTS_ID: "/api/v1/posts/:id",
  POSTS_FLAG: "/api/v1/posts/:id/flag",
  POSTS_BLOCK: "/api/v1/posts/:id/block",
  POST_DETAIL: "/api/v1/posts/:id/detail",
  POSTS_TOP_RATED: "/api/v1/top-rated/posts",
  POSTS_RECENT: "/api/v1/recent/posts",
  POSTS_PENDING: "/api/v1/pending/posts",
  POSTS_BY_TRIP: "/api/v1/trip/posts",

  //following api
  FOLLOW_USER: "/api/v1/follow",
  FOLLOWINGS: "/api/v1/followings",
  FOLLOWERS: "/api/v1/followers",

  //invites api
  INVITES: "/api/v1/invites",
  INVITES_ID: "/api/v1/invtes/:id",

  TRANSACTIONS: "/api/v1/transactions",
  TRANSACTIONS_ID: "/api/v1/transactions/:id",
  TRANSACTIONS_DECLINE: "/api/v1/transactions/decline",
  //TRANSACTION_REOPEN: '/api/v1/transaction/reopen',
  TRANSACTIONS_CANCEL: "/api/v1/transactions/cancel",
  TRANSACTIONS_COMPLETE: "/api/v1/transactions/complete",
  TRANSACTIONS_ACCEPT: "/api/v1/transactions/accept",
  TRANSACTIONS_GET_ITEM: "/api/v1/transactions/get-item",
  TRANSACTIONS_GIVE_ITEM: "/api/v1/transactions/give-item",
  TRANSACTIONS_FEEDBACK: "/api/v1/transactions/feedback",
  TRANSACTIONS_RETRIEVE_PAYMENT_INTENT:
    "/api/v1/transactions/retrieve-payment-intent",
  TRANSACTIONS_UPDATE_ON_PAYMENT_AUTH:
    "/api/v1/transactions/retried-auth-payment",
  TRANSACTIONS_CHARGE_ON_NEW_CARD: "/api/v1/transactions/charge-on-new-card",

  POST_LIKE: "/api/v1/post/likes",
  COMMENT_LIKE: "/api/v1/comment/likes",
  TRIP_LIKE: "/api/v1/trip/likes",

  REMOVE_POST_LIKE: "/api/v1/post/likes/:id",
  REMOVE_COMMENT_LIKE: "/api/v1/comment/likes/:id",
  REMOVE_TRIP_LIKE: "/api/v1/trip/likes/:id",

  PAYMENT_KEY_CREATE: "/api/v1/ephemeral_keys",
  ONBOARD_REDIRECT_PAGE: "/api/v1/stripe/token",
  PAYMENT_SETUP_INTENT: "/api/v1/stripe/setup-intent",

  USER_LOCATION: "/api/v1/location",

  COMMENTS: "/api/v1/comments",

  DISPUTE_OPEN: "/api/v1/dispute/open",
  DISPUTE_RESOLVE: "/api/v1/dispute/resolve",
  DIPUTE_REJECT: "/api/v1/dispute/reject",

  STRIPE_TOKEN_URI: "https://connect.stripe.com/oauth/token",
  STRIPE_EXPRESS_CREATE_LOGIN: "/api/v1/stripe/express/login-link",

  GET_BADGE_COUNT: "/api/v1/badge",

  ADMIN_SETTING: "/api/v1/admin-setting",
  ADMIN_RESET_PASSWORD: "/api/v1/admin/reset/password",
  STRIPE_WEBHOOK: "/api/v1/webhook",

  STRIPE_DISCONNECT: "/api/v1/stripe/disconnect",
};

module.exports.v2 = {
  ADMIN_LOGIN: "/api/v2/admin/login",
  ADMIN_LOGOUT: "/api/v2/admin/logout",
  CUSTOMER_AUTH: "/api/v2/auth/login/email",
  CUSTOMER_REGISTER: "/api/v2/register",
  CUSTOMER_LOGOUT: "/api/v2/auth/logout",

  ADMIN_TRANSACTIONS_GET_LIST: "/api/v2/admin/transactions",
  ADMIN_TRANSACTIONS_GET_BY_ID: "/api/v2/admin/transactions/:id",
  ADMIN_TRANSACTIONS_UPDATE_STATUS_BY_ID: "/api/v2/admin/transactions/:id",

  //customer api

  CUSTOMER_RESET_PASSWORD_WITHOUT_LOGIN: "/api/v2/customer/unlogged/reset-pwd",
  CUSTOMER_RESET_PASSWORD_WITHOUT_LOGIN_EMAIL:
    "/api/v2/customer/unlogged/email",
  CUSTOMERS_ID: "/api/v2/users/:id",
  CUSTOMERS: "/api/v2/users",
  CUSTOMER_NOTIFICATION: "/api/v2/users/:id/notification",
  CUSTOMER_RESET_PASSWORD: "/api/v2/user/reset-pwd",
  CUSTOMERS_NEAR_BY: "/api/v2/nearby/users",
  CUSTOMER_UPDATE_EMAIL: "/api/v2/user/update-email",
  CUSTOMER_UPDATE_INFORMATION: "/api/v2/user/update-information",
  CUSTOMER_UPDATE_PASSWORD: "/api/v2/user/update-password",
  CUSTOMER_REPORT: "/api/v2/users/report",
  CUSTOMER_BLOCK: "/api/v2/users/block",
  CUSTOMER_BLOCK_LIST: "/api/v2/users/block-list",
  CREATE_RATING: "/api/v2/users/create-rating",
  VALIDATE_USER: "/api/v2/users/validate",

  //following api
  FOLLOW_USER: "/api/v2/follow",
  FOLLOWINGS: "/api/v2/followings",
  FOLLOWERS: "/api/v2/followers",

  REMOVE_POST_LIKE: "/api/v2/post/likes/:id",
  POST_LIKE: "/api/v2/post/likes",
  COMMENT_LIKE: "/api/v2/comment/likes",
  TRIP_LIKE: "/api/v2/trip/likes",

  USER_LOCATION: "/api/v2/location",

  APP_VERSION: "/api/v2/version",

  //chats api
  CHAT_ROOMS: "/api/v2/chat-rooms",
  CHAT_ROOMS_ID: "/api/v2/chat-rooms/:id",

  MESSAGES: "/api/v2/messages",
  MESSAGES_ID: "/api/v2/messages/:id",
  MESSAGE_AS_READ: "/api/v2/message/read",

  ADMIN_SETTING: "/api/v2/admin-setting",
  ADMIN_RESET_PASSWORD: "/api/v2/admin/reset/password",
  ADMINS: "/api/v2/admins",
  ADMIN_CREATE: "/api/v2/admin",
  ADMIN_PUSH_NOTIFICATION: "/api/v2/notification/push",
  ADMIN_UPDATE_USER: "/api/v2/admin/users/:id",
  POSTS: "/api/v2/posts",
  POST_CREATE: "/api/v2/post",
  POST_CREATE_VOTE: "/api/v2/post/:id/vote",
  POST_VOTE: "/api/v2/post/:id/vote/:vote_id",
  POSTS_ID: "/api/v2/posts/:id",
  POSTS_FLAG: "/api/v2/posts/:id/flag",
  POSTS_BLOCK: "/api/v2/posts/:id/block",
  POST_DETAIL: "/api/v2/posts/:id/detail",
  POSTS_TOP_RATED: "/api/v2/top-rated/posts",
  POSTS_RECENT: "/api/v2/recent/posts",
  POSTS_PENDING: "/api/v2/pending/posts",
  POSTS_BY_TRIP: "/api/v2/trip/posts",
  POSTS_RECOMMENDATION: "/api/v2/getrecommendations",
  CATEGORIES: "/api/v2/categories",

  POST_METRICS_UPDATE: "/api/v2/post-metrics/:id/update",

  USER_POST_INTERACTION_LOG_CREATE: "/api/v2/user-post-interaction-log",
  USER_USER_INTERACTION_LOG_CREATE: "/api/v2/user-user-interaction-log",
  USER_TRANSACTION_LOG_CREATE: "/api/v2/user-transaction-log",

  //report api
  REPORT_ACTIVE_USER: "/api/v2/user-active",
  REPORT_STICK_USER: "/api/v2/user-stick",
  TRANSACTIONS_FEEDBACK: "/api/v2/transactions/feedback",

  TRANSACTIONS: "/api/v2/transactions",
  TRANSACTIONS_ID: "/api/v2/transactions/:id",
  TRANSACTIONS_DECLINE: "/api/v2/transactions/decline",
  //TRANSACTION_REOPEN: '/api/v2/transaction/reopen',
  TRANSACTIONS_CANCEL: "/api/v2/transactions/cancel",
  TRANSACTIONS_COMPLETE: "/api/v2/transactions/complete",
  TRANSACTIONS_ACCEPT: "/api/v2/transactions/accept",
  TRANSACTIONS_GET_ITEM: "/api/v2/transactions/get-item",
  TRANSACTIONS_GIVE_ITEM: "/api/v2/transactions/give-item",
  TRANSACTIONS_RETRIEVE_PAYMENT_INTENT:
    "/api/v2/transactions/retrieve-payment-intent",
  TRANSACTIONS_UPDATE_ON_PAYMENT_AUTH:
    "/api/v2/transactions/retried-auth-payment",
  TRANSACTIONS_CHARGE_ON_NEW_CARD: "/api/v2/transactions/charge-on-new-card",

  PAYMENT_KEY_CREATE: "/api/v2/ephemeral_keys",
  ONBOARD_REDIRECT_PAGE: "/api/v2/stripe/token",
  PAYMENT_SETUP_INTENT: "/api/v2/stripe/setup-intent",
  STRIPE_EXPRESS_CREATE_LOGIN: "/api/v2/stripe/express/login-link",

  //dashbord
  GET_REPORT_DATA: "/api/v2/report",
  GET_TRANSACTION_GRAPH: "/api/v2/transaction-graph",
  GET_ACTIVITY_USERS: "/api/v2/activity-users",
  GET_REVENUE_DATA: "/api/v2/revenue",
  GET_NUMERIC_REPORT: "/api/v2/numeric-report",

  //share
  GENERATE_SHARE_LINK: "/api/v2/shareLink/:postId",
  EXCHANGE_SHARE_LINK: "/api/v2/exchangeEncryptedId",
  SUCCESS_SHARE: "/api/v2/successShare",

  //pause
  PAUSE_VIDEO: "/api/v2/pauseVideo",

  //get braintree Token
  GET_BRAINTREE_TOKEN: "/api/v2/get-braintree-token",
  ONBOARD_PAYPAL_REDIRECT_PAGE: "/api/v2/paypal/token",
  CREATE_PAYPAL_PAYMENT: "/api/v2/paypal/create-payment",
  CREATE_PAYPAL_PAYMENT_SUCCESS: "/api/v2/paypal/create-payment-success",
  CREATE_PAYPAL_PAYMENT_ERROR: "/api/v2/paypal/create-payment-error",

  //Livestream
  LIVESTREAM_TOKEN: "/api/v2/livestream-token",
  LIVESTREAM_JOIN: "/api/v2/livestream/join/:post_id",
  LIVESTREAM_DISCONNECT: "/api/v2/livestream/disconnect/:post_id",
  LIVESTREAM_CHARGE_CUSTOMER : "/api/v2/livestream/charge/:post_id",
  LIVESTREAM_TIPPING_MONEY : "/api/v2/livestream/tipping-money/:post_id",
  LIVESTREAM_REMOVE_USER: '/api/v2/livestream/remove-user/:post_id/:user_id',
  LIVESTREAM_REMOVE_USER_ROLE: '/api/v2/livestream/remove-user-role/:post_id/:user_id',
  LIVESTREAM_SEND_INVITATION : "/api/v2/livestream/send-invitation/:post_id",
  LIVESTREAM_SEND_INVITATIONS : "/api/v2/livestream/send-invitations/:post_id",
  LIVESTREAM_ACCEPT_INVITATION : "/api/v2/livestream/accept-invitation/:post_id",
  LIVESTREAM_MUTE_USER: "/api/v2/livestream/:post_id/mute/:user_id",
  LIVESTREAM_RECORDING: "/api/v2/livestream/recording/:post_id",
  LIVESTREAM_STOP_RECORDING: "/api/v2/livestream/stop/:post_id",
  //ROOM CHAT
  ROOM_CHAT_SEND_MESSAGE: "/api/v2/room-chat/send-message/:room_chat_id",
};

module.exports.v3 = {
  ADMIN_LOGIN: "/api/v3/admin/login",
  ADMIN_LOGOUT: "/api/v3/admin/logout",
  CUSTOMER_AUTH: "/api/v3/auth/login/email",
  CUSTOMER_REGISTER: "/api/v3/register",
  CUSTOMER_LOGOUT: "/api/v3/auth/logout",
  //customer api
  ADMIN_TRANSACTIONS_GET_LIST: "/api/v3/admin/transactions",
  ADMIN_TRANSACTIONS_GET_BY_ID: "/api/v3/admin/transactions/:id",
  ADMIN_TRANSACTIONS_UPDATE_STATUS_BY_ID: "/api/v3/admin/transactions/:id",

  CUSTOMER_RESET_PASSWORD_WITHOUT_LOGIN: "/api/v3/customer/unlogged/reset-pwd",
  CUSTOMER_RESET_PASSWORD_WITHOUT_LOGIN_EMAIL:
    "/api/v3/customer/unlogged/email",
  CUSTOMERS_ID: "/api/v3/users/:id",
  CUSTOMERS: "/api/v3/users",
  CUSTOMER_NOTIFICATION: "/api/v3/users/:id/notification",
  CUSTOMER_RESET_PASSWORD: "/api/v3/user/reset-pwd",
  CUSOMTERS_NEAR_BY: "/api/v3/nearby/users",
  CUSTOMER_UPDATE_EMAIL: "/api/v3/user/update-email",
  CUSTOMER_UPDATE_INFORMATION: "/api/v3/user/update-information",
  CUSTOMER_UPDATE_PASSWORD: "/api/v3/user/update-password",
  CUSTOMER_REPORT: "/api/v3/users/report",
  CUSTOMER_BLOCK: "/api/v3/users/block",
  CUSTOMER_BLOCK_LIST: "/api/v3/users/block-list",
  CREATE_RATING: "/api/v3/users/create-rating",
  VALIDATE_USER: "/api/v3/users/validate",

  //following api
  FOLLOW_USER: "/api/v3/follow",
  FOLLOWINGS: "/api/v3/followings",
  FOLLOWERS: "/api/v3/followers",

  REMOVE_POST_LIKE: "/api/v3/post/likes/:id",
  POST_LIKE: "/api/v3/post/likes",
  COMMENT_LIKE: "/api/v3/comment/likes",
  TRIP_LIKE: "/api/v3/trip/likes",

  USER_LOCATION: "/api/v3/location",

  APP_VERSION: "/api/v3/version",

  //chats api
  CHAT_ROOMS: "/api/v3/chat-rooms",
  CHAT_ROOMS_ID: "/api/v3/chat-rooms/:id",

  MESSAGES: "/api/v3/messages",
  MESSAGES_ID: "/api/v3/messages/:id",
  MESSAGE_AS_READ: "/api/v3/message/read",

  ADMIN_SETTING: "/api/v3/admin-setting",
  ADMIN_RESET_PASSWORD: "/api/v3/admin/reset/password",
  ADMINS: "/api/v3/admins",
  ADMIN_CREATE: "/api/v3/admin",
  ADMIN_PUSH_NOTIFICATION: "/api/v3/notification/push",

  POSTS: "/api/v3/posts",
  POST_CREATE: "/api/v3/post",
  POSTS_ID: "/api/v3/posts/:id",
  POSTS_FLAG: "/api/v3/posts/:id/flag",
  POSTS_BLOCK: "/api/v3/posts/:id/block",
  POST_DETAIL: "/api/v3/posts/:id/detail",
  POSTS_TOP_RATED: "/api/v3/top-rated/posts",
  POSTS_RECENT: "/api/v3/recent/posts",
  POSTS_PENDING: "/api/v3/pending/posts",
  POSTS_BY_TRIP: "/api/v3/trip/posts",
  POSTS_RECOMMENDATION: "/api/v3/getrecommendations",
  CATEGORIES: "/api/v3/categories",

  POST_METRICS_UPDATE: "/api/v3/post-metrics/:id/update",

  USER_POST_INTERACTION_LOG_CREATE: "/api/v3/user-post-interaction-log",
  USER_USER_INTERACTION_LOG_CREATE: "/api/v3/user-user-interaction-log",
  USER_TRANSACTION_LOG_CREATE: "/api/v3/user-transaction-log",

  //report api
  REPORT_ACTIVE_USER: "/api/v3/user-active",
  REPORT_STICK_USER: "/api/v3/user-stick",
  TRANSACTIONS_FEEDBACK: "/api/v3/transactions/feedback",

  TRANSACTIONS: "/api/v3/transactions",
  TRANSACTIONS_ID: "/api/v3/transactions/:id",
  TRANSACTIONS_DECLINE: "/api/v3/transactions/decline",
  //TRANSACTION_REOPEN: '/api/v3/transaction/reopen',
  TRANSACTIONS_CANCEL: "/api/v3/transactions/cancel",
  TRANSACTIONS_COMPLETE: "/api/v3/transactions/complete",
  TRANSACTIONS_ACCEPT: "/api/v3/transactions/accept",
  TRANSACTIONS_GET_ITEM: "/api/v3/transactions/get-item",
  TRANSACTIONS_GIVE_ITEM: "/api/v3/transactions/give-item",
  TRANSACTIONS_RETRIEVE_PAYMENT_INTENT:
    "/api/v3/transactions/retrieve-payment-intent",
  TRANSACTIONS_UPDATE_ON_PAYMENT_AUTH:
    "/api/v3/transactions/retried-auth-payment",
  TRANSACTIONS_CHARGE_ON_NEW_CARD: "/api/v3/transactions/charge-on-new-card",

  PAYMENT_KEY_CREATE: "/api/v3/ephemeral_keys",
  ONBOARD_REDIRECT_PAGE: "/api/v3/stripe/token",
  PAYMENT_SETUP_INTENT: "/api/v3/stripe/setup-intent",
  STRIPE_EXPRESS_CREATE_LOGIN: "/api/v3/stripe/express/login-link",

  //dashbord
  GET_REPORT_DATA: "/api/v3/report",
  GET_TRANSACTION_GRAPH: "/api/v3/transaction-graph",
  GET_ACTIVITY_USERS: "/api/v3/activity-users",
  GET_REVENUE_DATA: "/api/v3/revenue",
  GET_NUMERIC_REPORT: "/api/v3/numeric-report",

  //share
  GENERATE_SHARE_LINK: "/api/v3/shareLink/:postId",
  EXCHANGE_SHARE_LINK: "/api/v3/exchangeEncryptedId",
  SUCCESS_SHARE: "/api/v3/successShare",

  //dispute
  DISPUTE_OPEN: "/api/v3/dispute/open",
  DISPUTE_RESOLVE: "/api/v3/dispute/resolve",
  DIPUTE_REJECT: "/api/v3/dispute/reject",

  //pause
  PAUSE_VIDEO: "/api/v3/pauseVideo",
};



// WEBPACK FOOTER //
// ./common/constants/paths/api.js